/*
 * Project: xpenser-client
 * FilePath: /src/app/components/auth-logout/index.tsx
 * File: index.tsx
 * Created Date: Friday, September 18th 2020, 4:24:50 pm
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Fri Sep 18 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 * <<licensetext>>
 */

import React, { useEffect, useContext } from 'react'
import { Redirect } from 'react-router-dom'

import { Context as AuthContext } from '@components/auth'

export const LogoutComponent = () => {
  const { setAuthentication } = useContext(AuthContext)
  useEffect(() => {
    document.cookie = `jwt=null; Max-Age=-1; Path=/;`
    setAuthentication(false)
  }, [setAuthentication])
  return (
    <>
      <p>Logging out...</p>
      <Redirect to="/" />
    </>
  )
}

export default LogoutComponent
